import Sidebar from '../components/Sidebar.jsx';
import PageHeader from '../components/PageHeader.jsx';
import '../styles/all.css'
import '../styles/fonts.css';


const Safety = () => {
let SoftwareImg = 'https://static.igem.wiki/teams/5066/global/bgpic.png';
let safety = 'https://static.igem.wiki/teams/5066/wetlab/safety.png';
let biosafety1 = 'https://static.igem.wiki/teams/5066/wetlab/biosafety1.png';



    let sections =[
        {id:'s1', name:'Safety in the Laboratory'},
        {id:'s2', name:'Safety Research Design'},
        {id:'s3', name:'Biosafety and Synthetic Biology Discussion'},
        {id:'s4', name:'References'},
    ];


    return (
        <div className='bg-[#fef9e3]'>
            <PageHeader img={SoftwareImg} title={'Safety'}  customPicture={<img src={'https://static.igem.wiki/teams/5066/cover/wetlab.gif'} alt="Custom" className="w-44 h-44" />}
            />


            <div className='flex bg-gradient-to-b from-[#fef9e3] via-[#e8f3f7] to-[#feedfb]'>
               
                <Sidebar sections={sections}  />


                {/* Main Content */}
                <div className='flex-col w-full lg:p-[50px] p-[5px] space-y-16 bg-white rounded-2xl shadow-[-2px_4px_8px_-2px_rgba(0,0,0,0.2)]'>
                   
                    <div className='pb-12'>
                        <section>
                            <br>
                            </br>
                        <p className='mt-4 text-lg'>
                        Safety is the most important value and practice that all researchers, students, and laboratory users uphold when conducting microbiology and synthetic biology studies. At GEMS-Taiwan, we prioritize safety safeguarding laboratory personnel and the environment. 
                        
                        </p>
                        <br>
                        </br>
                        <br>
                        </br>
                        <br>
                        </br>
                        </section>
                        <section id='s1'>
                        <h2 className='text-3xl font-bold text-[#C94C67]'>
                        Safety in the Laboratory 
                            </h2>
                            <p className='mt-4 ml-5 font-bold text-xl text-[#C94C67]'>
                            Biosafety training, biosafety exam, and consent form   
                            </p>
                       
                            <p className='mt-2 ml-5'>
                            Before entering the lab, all personnel who were to be involved in the Wet Lab or in any other way affiliated with the lab were required to undergo a total of 5 hours of biosafety training regarding introduction to the laboratory, personal protection equipment, basic biosafety, spill management and rules in the lab. 
                            </p>
                            <p className='mt-2 ml-5 mb-2'>
                            Those who received biosafety training were then given a biosafety test, and those who did not receive full marks were not permitted to enter the lab. The biosafety quiz included accidental spills, basic cloning, and safety equipment questions. In addition, we also learned how to handle and dispose biohazardous materials, like <span className='italic'>Escherichia coli</span> and agar plates. Thus, ensuring all members are informed about the safety and risks of the lab allows them to protect themselves better and be safe in the lab. Furthermore, students and their guardians were asked to sign a form to confirm that they acknowledged the potential dangers of working in a lab.
                              </p>
                              <p className='mt-4 ml-5 font-bold text-[#C94C67] text-xl'>
                              Basic laboratory training 
                              </p>
                              <p className='mt-2 ml-5 mb-2'>
                              Before starting to clone our fragments, we had a month in May dedicated to lab training to solidify our laboratory skills. We learned how to conduct molecular biology experiments such as running gel electrophoresis, PCR, and pipetting. The lab training helped us familiarize ourselves with the equipment we will use in the laboratory. This training ensured that we would use the laboratory equipment with precaution to provide a safe environment for all personnel to work in. 

                              </p>
                              <p className='mt-2 ml-5 mb-2'>
                              Moreover, we were trained to handle our samples carefully by creating adequate environments to store, transfer, and use our samples. We have learned about the different biosafety levels, what to do in the case of a chemical spill, and how to react in the case of other potential problems in the lab.

                              </p>
                              <p className='mt-2 ml-5 mb-2'>
                              By doing this, the team effectively placed emphasis on biosafety and its importance.  
                              </p>

                                <img
                                    src={safety}
                                    alt='Team'
                                    className='w-3/4 max-w-4xl ml-5 h-auto'
                                />
                                <p className='ml-5 mb-4'>
                                Figure 1: We ensured biosafety in our laboratory, equipment and personnel  
                                </p>
                           <br>
                           </br>


                        </section>
                
                        <section id='s2'>
                            
                            <h2 className='mb-4 mt-10 text-3xl font-bold text-[#C94C67]'>
                                Safety Reserach Design 
                            </h2>
                            <p className='mt-2 ml-5'>
                            Our research project, Dengue Beeters aims to use non-pathogenic E. coli strains DH5α and BL21(DE3), which are classified as Risk Group 1 organism to produce various biolarvicidal toxins. 

                            </p>
                            <p className='mt-2 ml-5'>
                            The biolarvicidal proteins that we are aiming to produce are Cyt2ba, Vip3Aa, Cry2Aa, Xpp81Aa1, and BmK IT1, all of which have demonstrated larvicidal activity against <span className='italic'>Aedes albopictus</span> larvae in various studies. The proteins (Cyt2ba (Nisnevitch et al., 2006), Vip3Aa (Wang et al., 2020), Cry2Aa (Ricoldi et al., 2018) and Xpp81Aa1 (Wu et al., 2021)) are from <span className='italic'>Bacillus thuringiensis</span>, whereas BmK IT1 is protein from scorpion, <span className='italic'>Buthus martensii </span> Karsch (Gu et al., 2010). 

                            </p>
                            <p className='mt-2 ml-5'>
                            These toxins naturally produced from <span className='italic'>B. thuringiensis</span> and <span className='italic'>B. martensii </span> Karsch BmK IT1 toxins are mosquito-specific (Gu et al., 2010) and pose no harm to non-targeted organisms or the environment (Palma et al., 2014). 

                            </p>
                            <p className='mt-2 ml-5'>
                            Lastly, the geosmin in our beetroot peel is a naturally occurring chemical compound that does not pose toxicity risks (Lu et al., 2003). Our work involved small-scale production of beetroot powder, which did not pose any environmental issues (Abd El-Hack et al., 2022). Throughout the experiment in our laboratory, we strictly adhered to the biosafety rules and experimented under the instructor's supervision. 

                            </p>
                            <br>
                            </br>
                            <br>
                            </br>
                            </section>
                            <section id='s3'>
                            
                            <h2 className='mb-4 mt-10 text-3xl font-bold text-[#C94C67]'>
                            Biosafety and Synthetic Biology Discussion  
                            </h2>
                            <p className='mt-2 ml-5'>
                            In our interviews with professors, organizations, and specialists, we have discussed the biosafety issue to gain their insights, opinions, and potential concerns. We were particularly interested in the prospects and future of synthetic biology in vector control and the elimination of arthropod-borne diseases. 

                            </p>
                            <p className='mt-2 mb-6 ml-5'>
                            In all of our interviews, we asked the same questions on biosafety and discussed them with the invited interviewees. Our questions posted to the professors, various stakeholders, and field entomologists were shown in Figure 2. 

                            </p>
                            <img
                                    src={biosafety1}
                                    alt='Team'
                                    className='w-3/5 max-w-4xl ml-10 h-auto'
                                />
                                <p className='ml-5 mb-4'>
                                Figure 2: Continuous conversation with various stakeholders on the topic of biosafety and biosecurity   
                                </p>
                                <p className='mt-2 mb-6 ml-5'>
                                We received various answers and learned about their perspectives on synthetic biology. Some expressed reservations and were concerned about the challenges of synthetic biology, but some anticipated the breakthrough synthetic biology could bring humanity. We know biosafety is the biggest concern for many, and it is the most important value to uphold regarding recombinant or engineered organisms. Hence, during the Dengue Day that we organized as part of our HP and IHP efforts, we also arranged a session and booth to discuss biosafety with students and visitors who attended our event. 

                            </p>
                            <br>
                            </br>

                        </section>
                        <div className='pb-12'>
                        <section id="s4">
                            <h2 className="text-3xl mt-10 font-bold text-red-600">References
                            </h2>
                            <br>
                            </br>
                            <p className='ml-5 mt-2 mb-2'>
Abd El-Hack, M. E., El-Saadony, M. T., Elbestawy, A. R., Ellakany, H. F., Abaza, S. S., Geneedy, A. M., ... & El-Tarabily, K. A. (2022). Undesirable odor substances (geosmin and 2-methylisoborneol) in water environment: Sources, impacts and removal strategies. <span className='italic'>Marine Pollution Bulletin</span>, 178, 113579.
                            </p>
                            <p className='ml-5 mb-2'>
Gu, J. B., Dong, Y. Q., Peng, H. J., & Chen, X. G. (2010). A recombinant AeDNA containing the insect-specific toxin, BmK IT1 IT1, displayed an increasing pathogenicity on Aedes albopictus. <span className='italic'>The American Journal of Tropical Medicine and Hygiene</span>, 83(3), 614.
                            </p>
                           <p className='ml-5 mb-2'>
Lu, G., Edwards, C. G., Fellman, J. K., Mattinson, D. S., & Navazio, J. (2003). Biosynthetic origin of geosmin in red beets (Beta vulgaris L.). <span className='italic'>Journal of Agricultural and Food Chemistry</span>, 51(4), 1026-1029.
                           </p>
                           <p className='ml-5 mb-2'>
Nisnevitch, M., Cohen, S., Ben-Dov, E., Zaritsky, A., Sofer, Y., & Cahan, R. (2006). Cyt2Ba of Bacillus thuringiensis israelensis: Activation by putative endogenous protease. <span className='italic'>Biochemical and Biophysical Research Communications</span>, 344(1), 99–105.
                           </p>
                           <p className='ml-5 mb-2'>
Palma, L., Muñoz, D., Berry, C., Murillo, J., & Caballero, P. (2014). Bacillus thuringiensis toxins: an overview of their biocidal activity. <span className='italic'>Toxins</span>, 6(12), 3296-3325.
                           </p>
                           <p className='ml-5 mb-2'>
Ricoldi, M. C., Figueiredo, C. S., & Desidério, J. A. (2018). Toxicity of Cry2 proteins from Bacillus thuringiensis subsp. thuringiensis strain T01-328 against Aedes aegypti (Diptera: Culicidae). <span className='italic'>Arquivos do Instituto Biológico</span>, 85, e0132018.
                           </p>
                           <p className='ml-5 mb-2'>
Wang, J., Wang, J., He, J., Wu, J., Sun, J., Wang, R., & Zhang, W. (2020). Vip3Aa from Bacillus thuringiensis subsp. kurstaki HD1 is toxic to Aedes aegypti (Diptera: culicidae). <span className='italic'>Journal of Invertebrate Pathology</span>, 171, 107342.
                           </p>
                           <p className='ml-5 mb-2'>
Wu, J., Wei, L., He, J., Fu, K., Li, X., Jia, L.,  & Zhang, W. (2021). Characterization of a novel Bacillus thuringiensis toxin active against Aedes aegypti larvae. <span className='italic'>Acta Tropica</span>, 223, 106088.
                           </p>
                        </section>
                    </div>
                </div>
                </div>
            </div>
        </div>
    );
};


export default Safety;